import { Node, mergeAttributes } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import CustomTagsAI from '../customoptions/CustomTagsAI.vue';

export default Node.create({
    name: 'customTagsAI',
    group: 'inline',
    inline: true,
    selectable: false,
    atom: true,

    parseHTML() {
        return [
            {
                tag: 'span.custom-tags-and-fields',
                getAttrs: (element) => ({
                    label: element.innerText,
                }),
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'span',
            mergeAttributes(HTMLAttributes, {
                class: `custom-tags-and-fields custom-tags-and-fields__${
                    HTMLAttributes.type || 'default'
                }`,
            }),
            HTMLAttributes.label || 'default',
        ];
    },

    addNodeView() {
        return VueNodeViewRenderer(CustomTagsAI, {
            stopEvent() {
                return false;
            },
        });
    },

    addAttributes() {
        return {
            type: {
                default: 'default',
            },
            label: {
                default: 'default',
            },
            hash: {
                default: '',
            },
            prompt: {
                default: '',
            },
            isDraggable: {
                default: true,
            },
            isHovered: {
                default: false,
            },
            isFocused: {
                default: false,
            },
            isDisabled: {
                default: false,
            },
        };
    },

    addCommands() {
        return {
            insertCustomTagsAI:
                (props) =>
                ({ tr, commands }) => {
                    const { $from } = tr.selection;
                    const from = tr.mapping.map($from.pos);
                    commands.insertContentAt(from, {
                        type: this.name,
                        attrs: props,
                    }),
                        {
                            parseOptions: {
                                preserveWhitespace: 'full',
                            },
                        };
                    return true;
                },
        };
    },
});
